export enum PositionPage {
    FIRST_PAGE = 'FIRST_PAGE',
    LAST_PAGE = 'LAST_PAGE',
}

export const pagination = (data: any, pageSize: number, currentPage = 1) => {
    const total = data?.length;

    if (!total) return null;
    const pages = data.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    const positionPage = {
        first: currentPage <= 1,
        last: currentPage >= total / pageSize,
    };

    const show = pages && (!positionPage?.first || !positionPage?.last);

    const result = {
        data: pages,
        total,
        currentPage,
        pageSize,
        positionPage,
        show,
    };

    return result;
};

export const changePage = (type: 'prev' | 'next', setCurrentPage: any) => {
    setCurrentPage((prev: number) => (type === 'prev' ? prev - 1 : prev + 1));
};
